import { render, staticRenderFns } from "./DenemeTahtasi.vue?vue&type=template&id=da8a1458"
import script from "./DenemeTahtasi.vue?vue&type=script&lang=ts"
export * from "./DenemeTahtasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports